import Header from "../components/Header";
import Fondo from "../assets/serv.png";
import F1 from "../assets/1.png";
import F2 from "../assets/2.png";
import F3 from "../assets/3.png";
import F4 from "../assets/4.png";
import Footer from "../components/Footer";

const Services = () => {
	return (
		<>
			<Header />
			<div>
				<div
					className="w-full h-[60vh] bg-cover bg-center bg-no-repeat flex items-center justify-center"
					style={{ backgroundImage: `url(${Fondo})` }}
				>
					<h1 className="text-5xl text-white font-bold">Servicios</h1>
				</div>
				<p className="text-sm p-4 md:px-44 md:py-16 text-gray-600">
					Ofrecemos una amplia variedad de servicios, desde atención materna
					hasta el cuidado de ancianos, pasando por pediatría y odontología.
					Nuestro objetivo es ayudar a las personas a mantener una alta calidad
					de vida por medio de las mejores prácticas sanitarias, y todo nuestro
					personal está volcado en conseguirlo. Proporcionamos soluciones
					integrales que satisfacen todas sus necesidades sanitarias.
				</p>
				<section className="relative grid grid-cols-1 md:grid-cols-2">
					<div
						className="h-[50vh] w-full bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
						style={{ backgroundImage: `url(${F1})` }}
					></div>
					<div className="p-4 md:p-12 gap-4 flex flex-col text-justify h-[50vh] justify-center">
						<h1 className="text-2xl font-bold">Prestadora de servicios</h1>
						<p>
							Somos una empresa dedicada a brindar soluciones especializadas en
							diversos sectores, ofreciendo mano de obra calificada, equipo
							adecuado y un enfoque centrado en la calidad y la eficiencia.
							Nuestro objetivo es facilitar las operaciones de nuestros clientes
							mediante un servicio confiable, puntual y adaptado a sus
							necesidades específicas. estamos comprometidos con el cumplimiento
							y la mejora continua
						</p>
					</div>
				</section>
				<section className="relative grid grid-cols-1 md:grid-cols-2">
					<div className="order-2 md:order-1 p-4 md:p-12 gap-4 flex flex-col text-justify h-[50vh] justify-center">
						<h1 className="text-2xl font-bold">
							Consultoría en Gestión Empresarial
						</h1>
						<p>
							Ayudamos a empresas a optimizar sus procesos, mejorar su
							rendimiento y alcanzar sus objetivos mediante asesoría estratégica
							en gestión empresarial. Desarrollamos soluciones a la medida para
							incrementar tu competitividad.
						</p>
					</div>
					<div
						className="order-1 md:order-2 h-[50vh] w-full bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
						style={{ backgroundImage: `url(${F2})` }}
					></div>
				</section>
				<section className="relative grid grid-cols-1 md:grid-cols-2">
					<div
						className="h-[50vh] w-full bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
						style={{ backgroundImage: `url(${F3})` }}
					></div>
					<div className="p-4 md:p-12 gap-4 flex flex-col text-justify h-[50vh] justify-center">
						<h1 className="text-2xl font-bold">
							Renta de Hidrolavadoras y Fumigadoras
						</h1>
						<p>
							Ofrecemos un servicio accesible y eficiente de renta de
							hidrolavadoras y fumigadoras de alto rendimiento, ideales para
							limpieza industrial, fachadas, patios, maquinaria o control de
							plagas. Nuestros equipos están en óptimas condiciones y
							disponibles en distintas capacidades, según tus necesidades.
						</p>
					</div>
				</section>
				<section className="relative grid grid-cols-1 md:grid-cols-2">
					<div className="order-2 md:order-1 p-4 md:p-12 gap-4 flex flex-col text-justify h-[50vh] justify-center">
						<h1 className="text-2xl font-bold">
							Mantenimiento y Limpieza Industrial
						</h1>
						<p>
							Realizamos mantenimiento y limpieza profesional en entornos
							industriales, asegurando espacios seguros, funcionales y libres de
							contaminantes. Nuestro equipo está capacitado para intervenir en
							áreas de difícil acceso, líneas de producción, entre otros.
							Utilizamos productos y técnicas que cumplen con los más altos
							estándares de seguridad e higiene, garantizando resultados
							duraderos y una imagen impecable para tu empresa.
						</p>
					</div>
					<div
						className="order-1 md:order-2 h-[50vh] w-full bg-cover bg-center group-hover:scale-110 transition-transform duration-500"
						style={{ backgroundImage: `url(${F4})` }}
					></div>
				</section>
			</div>
			<Footer />
		</>
	);
};

export default Services;
